import set from "lodash/set";
import get from "lodash/get";
import forOwn from "lodash/forOwn";
import isArray from "lodash/isArray";
// import filter from 'lodash/filter';
import {
    getCurrentPageSchema,
    getDefaultValueForComponent,
    fetchDataPromise,
    UnauthorizedError,
    calculatePath
} from "../../utils";
import Promise from "promise";

export const ACTIONS = {
    SET_PAGE: "SET_PAGE",
    SET_ANSWERS: "SET_ANSWERS",
    SET_PAGE_ANSWERS: "SET_PAGE_ANSWERS",
    SUBMIT_AND_SET_PAGE: "SUBMIT_AND_SET_PAGE",
    SET_SCHEMA: "SET_SCHEMA",
    SET_DONE: "SET_DONE",
    SET_RESULT: "SET_RESULT",
    GOT_USER: "GOT_USER",
    AINT_GOT_USER: "AINT_GOT_USER",
    AINT_GOT_SCHEMA: "AINT_GOT_SCHEMA",
    UPDATING_RESPONSE: "UPDATING_RESPONSE",
    UPDATED_RESPONSE: "UPDATED_RESPONSE",
    FAILED_UPDATING_RESPONSE: "FAILED_UPDATING_RESPONSE",
    FAILED_SAVING_DONE: "FAILED_SAVING_DONE",
    SAVING_DONE: "SAVING_DONE",
    GETTING_LAST_STATE: "GETTING_LAST_STATE",
    GOT_LAST_STATE: "GOT_LAST_STATE",
    LOGOUT: "LOGOUT",
    LOGGED_IN: "LOGGED_IN",
    CALCULATE_TOTALS: "CALCULATE_TOTALS",
    GO_BACK: "GO_BACK",
    SET_ALERT_DANGER: "SET_ALERT_DANGER",
    SET_ALERT_WARNING: "SET_ALERT_WARNING",
    SET_ALERT_SUCCESS: "SET_ALERT_SUCCESS",
    SET_ALERT_INFO: "SET_ALERT_INFO",
    CLEAR_ALERTS: "CLEAR_ALERTS",
    CHECKING_LOGIN: "CHECKING_LOGIN",
    CHECKED_LOGIN: "CHECKED_LOGIN",
    REQUEST_LOGIN_CHECK: "REQUEST_LOGIN_CHECK",
    CHECK_VERSION: "CHECK_VERSION",
    VERSION_CHECK_SUCCESS: "VERSION_CHECK_SUCCESS",
    VERSION_CHECK_FAILED: "VERSION_CHECK_FAILED",
    OUTDATED_VERSION: "OUTDATED_VERSION",
    RESET_ASSESSMENT: "RESET_ASSESSMENT"
};

// Somebody please move this somewhere better?  -Israel
export const getUser = async dispatch => {
    dispatch(aintGotUser());

    // try {
    //     let user = await fetchData('/session/user')
    //     dispatch(gotUser(user))
    //     dispatch(loggedIn())
    // } catch(err) {
    //     if (err instanceof UnauthorizedError) {
    //         console.log('got an unauthorized error, logging out, redirecting to login page')
    //         dispatch(logout())
    //         dispatch(setAlertDanger({
    //             message: 'You do not have permission to view the admin area!',
    //             timeout: 3000,
    //             onDismiss: () => { dispatch(clearAlerts()) }
    //         }))
    //     } else {
    //         console.log("user request error:", err)
    //         dispatch(logout())
    //         return
    //     }
    // }

    // create a timestamp to attach to avoid caching
    const now = Date.now();
    return fetchDataPromise("/session/user?t=" + now)
        .then(response => {
            return response.json();
        })
        .then(function(user) {
            dispatch(gotUser(user));
            dispatch(loggedIn());
        })
        .catch(function(err) {
            if (err instanceof UnauthorizedError) {
                console.log(
                    "got an unauthorized error, logging out, redirecting to login page"
                );
                dispatch(logout());
                // dispatch(setAlertDanger({
                //     message: 'You do not have permission to view the admin area!',
                //     timeout: 3000,
                //     onDismiss: () => { dispatch(clearAlerts()) }
                // }))
                return;
            } else {
                console.error("user request error:", err);
                dispatch(logout());
                return Promise.reject(err);
            }
        });
};

// Somebody please move this somewhere better?  -Israel
export function getSchema(dispatch) {
    dispatch(aintGotSchema());
    // create a timestamp to attach to avoid caching
    const now = Date.now();
    return fetchDataPromise("/schema/latest?t=" + now)
        .then(response => {
            return response.json();
        })
        .then(function(schemaInfo) {
            dispatch(setSchema(schemaInfo));
        })
        .catch(function(err) {
            if (err instanceof UnauthorizedError) {
                console.log(
                    "got an unauthorized error, logging out, redirecting to login page"
                );
                dispatch(logout());
                // dispatch(setAlertDanger({
                //     message: 'You do not have permission to view the admin area!',
                //     timeout: 3000,
                //     onDismiss: () => { dispatch(clearAlerts()) }
                // }))
                return Promise.reject(err);
            } else {
                console.log("schema request error:", err);
                //dispatch(logout())
                return Promise.reject(err);
            }
        });
}

export function getLastState(dispatch) {
    dispatch(gettingLastState());
    // create a timestamp to attach into /last to avoid caching
    const now = Date.now();
    return fetchDataPromise("/response/last?t=" + now)
        .then(response => {
            return response.json();
        })
        .then(function(body) {
            dispatch(gotLastState(body.response));
            return body;
        })
        .catch(function(err) {
            if (err instanceof UnauthorizedError) {
                console.log(
                    "got an unauthorized error, logging out, redirecting to login page"
                );
                dispatch(logout());
                // dispatch(setAlertDanger({
                //     message: 'You do not have permission to view the admin area!',
                //     timeout: 3000,
                //     onDismiss: () => { dispatch(clearAlerts()) }
                // }))
                return Promise.reject(err);
            } else {
                console.log("response/last error:", err);
                //dispatch(logout())
                return Promise.reject(err);
            }
        });
}

export function getLastStateDefaultPage(dispatch, schemaInfo) {
    dispatch(gettingLastState());

    // create a timestamp to attach into /last to avoid caching
    const now = Date.now();
    return fetchDataPromise("/response/last?t=" + now)
        .then(response => {
            return response.json();
        })
        .then(function(body) {
            dispatch(gotLastState(body.response));
        })
        .catch(function(err) {
            if (err instanceof UnauthorizedError) {
                console.log(
                    "got an unauthorized error, logging out, redirecting to login page"
                );
                dispatch(logout());
                // dispatch(setAlertDanger({
                //     message: 'You do not have permission to view the admin area!',
                //     timeout: 3000,
                //     onDismiss: () => { dispatch(clearAlerts()) }
                // }))
                return Promise.reject(err);
            } else {
                console.log("response/last error:", err);
                const current_page_id = get(
                    schemaInfo,
                    ["schema", "X-Order", 0],
                    undefined
                );
                dispatch(setPage(current_page_id));
                return Promise.reject(err);
            }
        });
}

export function getLastStateThenSchema(dispatch) {
    dispatch(aintGotSchema());
    return getLastState(dispatch)
        .then(fullResponse => {
            // extract schema
            dispatch(setSchema(fullResponse.schema_version));
            return fullResponse.response;
        })
        .catch(err => {
            // no response was found, most likely user is new
            // swallow the error
            // get the latest schema
            // set the initial page
            // create a timestamp to attach to avoid caching
            const now = Date.now();
            return fetchDataPromise("/schema/latest?t=" + now)
                .then(schema => {
                    return schema.json();
                })
                .then(function(schemaInfo) {
                    dispatch(setSchema(schemaInfo));
                    dispatch(gettingLastState());
                    const current_page_id = get(
                        schemaInfo,
                        ["schema", "X-Order", 0],
                        undefined
                    );
                    dispatch(setPage(current_page_id));
                })
                .catch(err => {
                    if (err instanceof UnauthorizedError) {
                        console.log(
                            "got an unauthorized error, logging out, redirecting to login page"
                        );
                        dispatch(logout());
                        // dispatch(setAlertDanger({
                        //     message: 'You do not have permission to view the admin area!',
                        //     timeout: 3000,
                        //     onDismiss: () => { dispatch(clearAlerts()) }
                        // }))
                        return Promise.reject(err);
                    }
                    return Promise.reject(err);
                });
        });
}

export function getSchemaAndLastState(dispatch) {
    dispatch(aintGotSchema());
    // create a timestamp to attach to avoid caching
    const now = Date.now();
    return fetchDataPromise("/schema/latest?t=" + now)
        .then(schema => {
            return schema.json();
        })
        .then(function(schemaInfo) {
            dispatch(setSchema(schemaInfo));
            dispatch(gettingLastState());
            return getLastStateDefaultPage(dispatch, schemaInfo);
        })
        .catch(function(err) {
            if (err instanceof UnauthorizedError) {
                console.log(
                    "got an unauthorized error, logging out, redirecting to login page"
                );
                dispatch(logout());
                // dispatch(setAlertDanger({
                //     message: 'You do not have permission to view the admin area!',
                //     timeout: 3000,
                //     onDismiss: () => { dispatch(clearAlerts()) }
                // }))
                return Promise.reject(err);
            } else {
                console.log("schema/latest combined error:", err);
                //dispatch(logout())
                return Promise.reject(err);
            }
        });
}

export function updateResponse(dispatch, pages, schema_version_id, done) {
    dispatch(updatingResponse());

    console.log({ pages, schema_version_id, done });

    return fetchDataPromise("/response/" + schema_version_id, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(pages)
    })
        .then(function(response) {
            if (done) {
                dispatch(savingResponseDone());
            } else {
                dispatch(updatedResponse());
            }
        })
        .catch(function(error) {
            dispatch(failedUpdatingResponse(error));

            if (done) {
                dispatch(failedSavingResponseDone(error));
            }
        });
}

export function resetAssessment() {
    return {
        type: ACTIONS.RESET_ASSESSMENT
    };
}

export function deleteMyResponse(dispatch) {
    return fetchDataPromise("/response/me", {
        method: "DELETE",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        }
    }).then(function(response) {
        if (response.ok) {
            dispatch(resetAssessment());
            return response.json();
        }
        throw new Error("Delete failed");
    });
}

export function calculateTotals() {
    return {
        type: ACTIONS.CALCULATE_TOTALS,
        payload: undefined
    };
}

export function aintGotSchema() {
    return {
        type: ACTIONS.AINT_GOT_SCHEMA
    };
}

export function aintGotUser() {
    return {
        type: ACTIONS.AINT_GOT_USER
    };
}

export function gotUser(user) {
    return {
        type: ACTIONS.GOT_USER,
        payload: user
    };
}

export function updatingResponse() {
    return {
        type: ACTIONS.UPDATING_RESPONSE
    };
}

export function failedUpdatingResponse(error) {
    return {
        type: ACTIONS.FAILED_UPDATING_RESPONSE,
        payload: error
    };
}

export function failedSavingResponseDone(error) {
    return {
        type: ACTIONS.FAILED_SAVING_DONE,
        payload: error
    };
}

export function savingResponseDone() {
    return {
        type: ACTIONS.SAVING_DONE
    };
}

export function updatedResponse() {
    return {
        type: ACTIONS.UPDATED_RESPONSE
    };
}

/**
 * Action Creator for `SET_PAGE_ANSWERS`
 * @param {string | string[]} page
 * @param {*} form
 */
export function setPageAnswers(page, form, save = false) {
    return {
        type: ACTIONS.SET_PAGE_ANSWERS,
        payload: {
            page,
            form,
            save
        }
    };
}

/**
 * Action Creator for `SET_ANSWERS`
 * @param {*} form
 */
export function setForm(form) {
    return {
        type: ACTIONS.SET_ANSWERS,
        payload: form
    };
}

/**
 * Action Creator for `GO_BACK`
 * @param {string} page_id
 */
export function goBack(page_id) {
    return {
        type: ACTIONS.GO_BACK,
        payload: page_id
    };
}

/**
 * Action Creator for `SET_RESULTS`
 * @param {SetResultConfig} options
 */
export function setResult(options) {
    return {
        type: ACTIONS.SET_RESULT,
        payload: options
    };
}

/**
 * Action Creator `SET_PAGE`
 * @param {string} page
 */
export function setPage(page) {
    return {
        type: ACTIONS.SET_PAGE,
        payload: page
    };
}

/**
 * Action Creator for `SET_SCHEMA`
 * @param {object} schema
 */
export function setSchema(schema) {
    return {
        type: ACTIONS.SET_SCHEMA,
        payload: schema
    };
}

/**
 * Action Creator for `SET_DONE`
 */
export function setDone() {
    return {
        type: ACTIONS.SET_DONE,
        payload: undefined
    };
}

export function gettingLastState() {
    return {
        type: ACTIONS.GETTING_LAST_STATE
    };
}

export function gotLastState(state) {
    return {
        type: ACTIONS.GOT_LAST_STATE,
        payload: state
    };
}

/**
 * Action Creator for `SUBMIT_AND_SET_PAGE`
 * @param {string[]} submitted_pages
 * @param {string} current_page_id
 * @param {boolean} needs_review
 */
export function submitAndSetPage(submitted_pages, current_page_id) {
    return {
        type: ACTIONS.SUBMIT_AND_SET_PAGE,
        payload: {
            submitted_pages: submitted_pages,
            current_page_id: current_page_id
        }
    };
}

export function logout(inactive = false) {
    return {
        type: ACTIONS.LOGOUT,
        payload: inactive
    };
}

export function loggedIn() {
    return {
        type: ACTIONS.LOGGED_IN
    };
}

export function setAlertDanger(alert) {
    return {
        type: ACTIONS.SET_ALERT_DANGER,
        payload: alert
    };
}

export function setAlertWarning(alert) {
    return {
        type: ACTIONS.SET_ALERT_WARNING,
        payload: alert
    };
}

export function setAlertSuccess(alert) {
    return {
        type: ACTIONS.SET_ALERT_SUCCESS,
        payload: alert
    };
}

export function setAlertInfo(alert) {
    return {
        type: ACTIONS.SET_ALERT_INFO,
        payload: alert
    };
}

export function clearAlerts() {
    return {
        type: ACTIONS.CLEAR_ALERTS
    };
}

export function checkingLogin() {
    return {
        type: ACTIONS.CHECKING_LOGIN
    };
}

export function checkedLogin() {
    return {
        type: ACTIONS.CHECKED_LOGIN
    };
}

export function requestLoginCheck() {
    return {
        type: ACTIONS.REQUEST_LOGIN_CHECK
    };
}

export function checkVersion() {
    return {
        type: ACTIONS.CHECK_VERSION
    };
}

export function checkVersionSuccess(version) {
    return {
        type: ACTIONS.VERSION_CHECK_SUCCESS,
        payload: version
    };
}

export function checkVersionFailed() {
    return {
        type: ACTIONS.VERSION_CHECK_FAILED
    };
}

export function outdatedVersion() {
    return {
        type: ACTIONS.OUTDATED_VERSION
    };
}

/**
 * @typedef WriteClass
 * @type {object}
 * @property {string} current_page_id
 * @property {boolean} done
 * @property {string[]} submitted_pages
 * @property {object} form
 * @property {object} schema
 */

/**
 * @type WriteClass
 */
export const DEFAULT_STATE = {
    current_page_id: undefined,
    done: false,
    needs_review: false,
    needs_review_accept_page: undefined,
    needs_review_reject_page: undefined,
    needs_review_reset_page: undefined,
    needs_review_description: undefined,
    needs_review_accept_field: undefined,
    needs_review_reviewed_field: undefined,
    approved: null,
    submitted_pages: [],
    form: {
        authentication: {
            authenticated: true
        }
    },
    schema: {},
    totals: {},
    final_result_id: undefined,
    user: {
        accountName: "",
        lastName: "",
        firstName: "",
        email: "",
        nickName: ""
    },
    loggedIn: false,
    checkedLogin: false,
    alerts: [],
    user_inactive: false,
    app_version: undefined
};

export const DEFAULT_ACTION = {
    type: "NONE",
    payload: undefined
};

/**
 * Set page to `action.payload` and set default values in `form`
 * @param {WriteClass} state
 * @param {*} action
 */
export function setPageReducer(state = DEFAULT_STATE, action = DEFAULT_ACTION) {
    const current_page_id = action.payload;
    const state_with_page_id = {
        ...state,
        current_page_id
    };

    const current_form_state = get(state, ["form", current_page_id], {});
    const [current_page_schema] = getCurrentPageSchema(state_with_page_id);
    let default_properties = {};
    forOwn(get(current_page_schema, ["properties"], {}), (property, key) => {
        // get defaults
        const d = getDefaultValueForComponent(property);
        set(default_properties, [key], d);
    });

    return {
        ...state_with_page_id,
        form: {
            ...state.form,
            [current_page_id]: {
                ...default_properties,
                ...current_form_state
            }
        }
    };
}

/**
 * Submit pages and set new current page
 * @param {WriteClass} state
 * @param {*} action
 */
export function submitAndSetPageReducer(
    state = DEFAULT_STATE,
    action = DEFAULT_ACTION
) {
    const submitted_pages = get(action, ["payload", "submitted_pages"], []);
    const current_page_id = get(action, ["payload", "current_page_id"]);
    const state_with_pages = {
        ...state,
        submitted_pages: submitted_pages
    };

    return setPageReducer(state_with_pages, setPage(current_page_id));
}

/**
 * Set answers for `action.page`
 * @param {WriteClass} state
 * @param {*} action
 */
export function setPageAnswersReducer(
    state = DEFAULT_STATE,
    action = DEFAULT_ACTION
) {
    const form = { ...state.form };
    set(form, action.payload.page, action.payload.form);

    return {
        ...state,
        form
    };
}

/**
 * Full reducer for `WriteClass` state
 * @param {WriteClass} state
 * @param {*} action
 */
export function writeClassReducer(
    state = DEFAULT_STATE,
    action = DEFAULT_ACTION
) {
    switch (action.type) {
        case ACTIONS.SET_PAGE: {
            return setPageReducer(state, action);
        }
        case ACTIONS.SET_ANSWERS: {
            return {
                ...state,
                form: action.payload
            };
        }
        case ACTIONS.SET_PAGE_ANSWERS: {
            return setPageAnswersReducer(state, action);
        }
        case ACTIONS.SUBMIT_AND_SET_PAGE: {
            return submitAndSetPageReducer(state, action);
        }
        case ACTIONS.SET_DONE: {
            return {
                ...state,
                done: true
            };
        }
        case ACTIONS.SET_SCHEMA: {
            const state_with_schema = {
                ...state,
                schema: action.payload.schema,
                schema_version_id: action.payload.id
            };
            return state_with_schema;
        }
        case ACTIONS.SET_RESULT: {
            const {
                final_result_id,
                current_page_id,
                submitted_pages,
                needs_review,
                needs_review_accept_page,
                needs_review_reject_page,
                needs_review_reset_page,
                needs_review_description,
                needs_review_accept_field,
                needs_review_reviewed_field,
                approved
            } = action.payload;
            // set result page answer
            //const state_after_set_answer = setPageAnswersReducer(state, setPageAnswers(...result_to_set));

            // if final_result_id is undefined, this is not the final 'complete' page
            const done = true;

            return {
                ...state,
                current_page_id,
                submitted_pages,
                final_result_id,
                done,
                needs_review: state.needs_review === true ? true : needs_review,
                needs_review_accept_page,
                needs_review_reject_page,
                needs_review_reset_page,
                needs_review_description,
                needs_review_accept_field,
                needs_review_reviewed_field,
                approved
            };
        }
        case ACTIONS.GET_USER:
            return state;
        case ACTIONS.GOT_USER:
            return {
                ...state,
                user: action.payload
            };
        case ACTIONS.AINT_GOT_USER:
            return {
                ...state,
                user: DEFAULT_STATE.user
            };
        case ACTIONS.GOT_LAST_STATE:
            return {
                ...state,
                ...action.payload
            };
        case ACTIONS.CALCULATE_TOTALS: {
            let totals = {};
            for (const property in state.schema.properties) {
                if (
                    get(state.schema.properties, [property, "type"]) ===
                    "calculated"
                ) {
                    let sum = calculatePath({
                        calculation_path: `schema.properties.${property}`,
                        write_class: state
                    });
                    totals[property] = sum;
                }
            }

            // console.log(totals);
            return {
                ...state,
                totals
            };
        }
        case ACTIONS.GO_BACK: {
            const back_page_id = get(action, ["payload"]);

            if (back_page_id === undefined) {
                return state;
            }

            const current_submitted_pages = get(state, ["submitted_pages"], []);
            const next_page_index = current_submitted_pages.findIndex(
                page_id => {
                    return back_page_id === page_id;
                }
            );

            // if the page to go back to is the current one, do nothing
            if (next_page_index === undefined) {
                return state;
            }

            // split current_submitted_pages
            const next_submitted_pages = current_submitted_pages.slice(
                0,
                next_page_index
            );
            let pages_to_reverse = current_submitted_pages.slice(
                next_page_index + 1
            );
            pages_to_reverse.push(get(state, ["current_page_id"]));

            let next_form = {
                ...state.form
            };

            // unset form
            if (isArray(pages_to_reverse)) {
                pages_to_reverse.forEach(page_id => {
                    next_form[page_id] = undefined;
                });
            }

            return {
                ...state,
                form: next_form,
                submitted_pages: next_submitted_pages,
                current_page_id: back_page_id
            };
        }
        case ACTIONS.LOGOUT:
            return {
                ...state,
                loggedIn: false,
                user: DEFAULT_STATE.user,
                user_inactive: action.payload
            };
        case ACTIONS.LOGGED_IN:
            return {
                ...state,
                loggedIn: true,
                user_inactive: false
            };
        case ACTIONS.SET_ALERT_DANGER:
            action.payload.type = "danger";
            return {
                ...state,
                alerts: [action.payload]
            };
        case ACTIONS.SET_ALERT_WARNING:
            action.payload.type = "warning";
            return {
                ...state,
                alerts: [action.payload]
            };
        case ACTIONS.SET_ALERT_SUCCESS:
            action.payload.type = "success";
            return {
                ...state,
                alerts: [action.payload]
            };
        case ACTIONS.SET_ALERT_INFO:
            action.payload.type = "info";
            return {
                ...state,
                alerts: [action.payload]
            };
        case ACTIONS.CLEAR_ALERTS:
            return {
                ...state,
                alerts: []
            };
        case ACTIONS.CHECKING_LOGIN:
            return {
                ...state,
                checkedLogin: false
            };
        case ACTIONS.CHECKED_LOGIN:
            return {
                ...state,
                checkedLogin: true
            };
        case ACTIONS.VERSION_CHECK_SUCCESS:
            return {
                ...state,
                app_version: action.payload
            };
        case ACTIONS.VERSION_CHECK_FAILED:
            return {
                ...state
            };
        case ACTIONS.RESET_ASSESSMENT:
            return {
                ...DEFAULT_STATE,
                schema: state.schema,
                schema_version_id: state.schema_version_id,
                user: state.user,
                loggedIn: state.loggedIn,
                checkedLogin: state.checkedLogin,
                current_page_id: get(state, ["schema", "X-Order", 0], undefined)
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/store/WriteClass/reducer.js